<template>
  <Landing
    v-if="pageModel"
    v-model="pageModel"
    :qaActions="qaActions"
    @rowEdit="$emit('rowEdit', $event)"
    @editTile="$emit('editTile', $event)"
    @documentCreated="$emit('documentCreated', $event)"
    @sessionExpired="$emit('sessionExpired', $event)"
    @openDocument="$emit('openDocument', $event)"
    @copyDocument="copyDocument"
    @documentChangedHandler="$emit('documentChangedHandler', $event)"
    @addDocument="$emit('addDocument', $event)"
  >
  </Landing>
</template>

<script>
import Landing from "@/components/landingPages/cLanding";
import landingUtils from "@/components/landingPages/landingUtils.js";

export default {
  name: "vLandingHolder",
  components: {
    Landing,
  },
  props: {
    qaActions: { type: Array },
    config: { type: String },
  },
  data: function () {
    return {
      isLoading: false,
      response: null,
      pageModel: null
    };
  },
  mounted() {},
  created() {
    this.init();
  },
  watch: {
    $route() {
      this.pageModel = null;
      const that = this;
      this.$nextTick(() => {
         that.init();
      });
    }
  },
  computed: {
  },
  methods: {
    init() {
      const configName = this.config || this.$route.name;
      const config = this.$loginState.getLandingConfig(configName);
      if (config && config.definition) {
        const definition = JSON.parse(config.definition);

        landingUtils.prepLandingPageDefinition(definition);

        definition.tabs.forEach((t) => {
          t.cols.forEach((c) => {
            c.rows = c.rows || [];
            c.rows.forEach((r) => {
              r.links = r.links?.map((l) => {
                l.isCreateLink = l.type === "createdoc";
                if (l.isCreateLink) {
                  l.isAccessible = true;
                  delete l.url;
                } else {
                  l.isExternal = l.url && l.url.startsWith("http");
                  if (!l.isExternal && l.url && l.url.charAt(0) === "/")
                    l.url = l.url.substring(1);
                  l.isAccessible =
                    l.isExternal ||
                    !l.url ||
                    !this.qaActions ||
                    this.qaActions.some(
                      (a) =>
                        a.name.toLowerCase() === l.url.toLowerCase().split("?")[0]
                    );
                }
                return l;
              })
              // FeatureTiles preserves inaccessible tiles (rendered as disabled)
              // so the per-tile width layout stays intact. All other control
              // types retain the legacy hide-on-inaccessible behaviour.
              .filter((l) => l.isAccessible || r.controlType === 'FeatureTiles') || [];
            })
          })
        });

        this.pageModel = definition;
      }
    },
    copyDocument(item, tmpl_id, uploaded, action_available_id_copy, lifecycle_id_destination) {
      this.$emit("copyDocument", item, tmpl_id, uploaded, action_available_id_copy, lifecycle_id_destination);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/vars";
</style>